






















import { Component, Vue, Prop } from 'vue-property-decorator';
import { IInterview } from '@/types/Interview';

@Component
export default class InterviewPostCard extends Vue {
  @Prop({ type: Number, required: true }) readonly id!: number;
  @Prop({ type: String, required: true }) readonly url!: string;
  @Prop({ type: String, required: true }) readonly title!: string;
  @Prop({ type: String, required: true }) readonly date!: string;
  @Prop({ type: String, required: true }) readonly category!: string;
  @Prop({ type: String, required: true }) readonly pref_name!: string;
  @Prop({ type: String, default: '' }) readonly thumbnail_image_url?: string;
  @Prop({ type: String, default: '' }) readonly thumbnail_image_alt?: string;
}
